import Loader from '@/components/atoms/Loader';
import styled from '@emotion/styled';

export const StyledLoader = styled(Loader)`
    height: '100vh';
`;
